/** @format */

import { useState } from "react";
import { useTranslation } from "react-i18next";

const ACKNOWLEDGED_STORAGE_KEY = "cookieNotice.acknowledged.v1";

const TITLE_ID = "cookie-notice-title";

const readIsAcknowledged = (): boolean => {
	try {
		return localStorage.getItem(ACKNOWLEDGED_STORAGE_KEY) === "true";
	} catch (error) {
		console.warn("failed to read cookie notice", error);
		return false;
	}
};

export const CookieNotice = () => {
	const { t } = useTranslation();
	const [isAcknowledged, setIsAcknowledged] = useState<boolean>(readIsAcknowledged);

	const acknowledge = () => {
		setIsAcknowledged(true);
		try {
			localStorage.setItem(ACKNOWLEDGED_STORAGE_KEY, "true");
		} catch (error) {
			console.warn("Failed to store the cookie notice acknowledgement", error);
		}
	};

	if (isAcknowledged) {
		return null;
	}

	return (
		<section
			aria-labelledby={TITLE_ID}
			className="fixed bottom-15 left-5 right-5 z-50 rounded-lg border border-(--public-color-border-default) bg-white p-4 text-(--public-color-text-default) shadow-lg sm:left-1/2 sm:right-auto sm:w-96 sm:-translate-x-1/2"
		>
			<h2 id={TITLE_ID} className="text-sm font-semibold">
				{t("cookieNotice.title")}
			</h2>
			<p className="mt-2 text-sm">{t("cookieNotice.message")}</p>
			<div className="mt-3 flex justify-end">
				<button
					type="button"
					onClick={acknowledge}
					className="cursor-pointer rounded-full bg-(--public-color-theme-primary) px-4 py-2 text-sm font-semibold text-white transition-transform hover:scale-105 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--public-color-theme-primary)"
				>
					{t("cookieNotice.acknowledge")}
				</button>
			</div>
		</section>
	);
};
